import { type FC } from "react";
import * as styles from "./styles.css";

const PublishStatus = {
  private: "掲載前",
  publication: "掲載中",
  publishedStopping: "掲載停止",
  entryStopping: "応募停止",
} as const;

type PublishStatusKeys = keyof typeof PublishStatus;

type Props = {
  publishStatus: "private" | "publication" | "publishedStopping";
  enterableFlag?: boolean;
};

export const PublishStatusLabel: FC<Props> = ({ publishStatus, enterableFlag }) => {
  let statusKey: PublishStatusKeys = publishStatus;
  if (publishStatus === "publication" && enterableFlag === false) {
    statusKey = "entryStopping";
  }

  return <span className={styles.publishStatusLabel[statusKey]}>{PublishStatus[statusKey]}</span>;
};
